/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/

// Helpers
import { getEndpoint } from '@lib/helpers'
import config from '@/config'
import axios from 'axios'

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * list support tickets
 */
export const list = async (params = []) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/support-tickets', params),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * show a support ticket
 */
export const show = async support_ticket_id => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'get',
            url: getEndpoint('/support-tickets/'+support_ticket_id),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * create a support ticket
 */
export const create = async data => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'post',
            data,
            url: getEndpoint('/support-tickets'),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * create a support ticket
 */
export const update = async (support_ticket_id, data) => {
    return new Promise(( resolve, reject ) => {
        axios({
            method: 'patch',
            data,
            url: getEndpoint('/support-tickets/'+support_ticket_id),
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

export const addMedia = async (support_ticket_id, payload) => {

    let formData = new FormData()
    for (let key in payload) {
        formData.append(key, payload[key])
    }

    return new Promise(( resolve, reject ) => {

        axios({
            method: 'post',
            url: getEndpoint('/support-tickets/' + support_ticket_id + '/media'),
            data: formData,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get user vehicle inventory
 * @returns
 */
export const getComments = async support_ticket_id => {

    return new Promise(( resolve, reject ) => {

        if (!support_ticket_id) {
            reject({message: 'support_ticket_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/support-tickets/' + support_ticket_id + '/comments'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * create a comment ono this asset
 * @returns
 */
export const createComment = async (support_ticket_id, comment_data) => {

    return new Promise(( resolve, reject ) => {

        if (!support_ticket_id) {
            reject({message: 'support_ticket_id missing'})
            return
        }

        axios({
            method: 'post',
            url: getEndpoint('/support-tickets/' + support_ticket_id + '/comment'),
            data: comment_data,
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

/**
 * get the comment participants for a given asset
 */
export const getCommentParticipants = async support_ticket_id => {

    return new Promise(( resolve, reject ) => {

        if (!support_ticket_id) {
            reject({message: 'support_ticket_id missing'})
            return
        }

        axios({
            method: 'get',
            url: getEndpoint('/support-tickets/'+support_ticket_id+'/comment-participants'),
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(( response ) => {
                resolve( response )
            })
            .catch(( error ) => {
                reject( error )
            })
    })
}

